import styled from "@emotion/styled";
import { Box } from "Components";

export const MentorRowsContainer = styled(Box)`
    background: #e1e1e1;
    margin-top: 15px;
    padding-bottom: 1px;
    animation: mentorRowsFadeIn 0.15s ease-out;

    @keyframes mentorRowsFadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

export const StickyHeaderOuter = styled(Box)`
    position: sticky;
    top: 0;
    z-index: 1;
    background: #fff;
`;
